import { useMediaQuery } from "react-responsive";

import { DesktopHeader } from "components/page-header/desktop-header";
import { MobileHeader } from "components/page-header/mobile-header";
import { screenSizes } from "consts";

type PageHeaderProps = {
  hideNavigation?: boolean;
  hidePolicyHeader?: boolean;
  tabs?: Record<string, string>[];
};

export const PageHeader = ({
  hideNavigation,
  hidePolicyHeader,
  tabs,
}: PageHeaderProps) => {
  const isMobile = useMediaQuery({
    maxWidth: screenSizes.laptop,
  });

  return isMobile ? (
    <MobileHeader hidePolicyHeader={hidePolicyHeader} tabs={tabs} />
  ) : (
    <DesktopHeader
      hideNavigation={hideNavigation}
      hidePolicyHeader={hidePolicyHeader}
      tabs={tabs}
    />
  );
};
